import { AssistentItem } from '../assistent_config';
import { IDs } from '../../../../helpers/IDs';

export function getAssistentConfigBWL(data: any, customCfg?: any): AssistentItem {
    const eingabe_BWL = {
        gliederung: '5.',
        name: 'BWL-Daten',
        description: 'Dies ist das Formular zur Eingabe der betriebswirtschaftlichen Daten.',
        type: 'EntityForm',
        entity: IDs.ENT_BETRIEBSDATEN,
        singleItem: true,
        configFlag: 'inputBWL',
        ...(customCfg || {})
    };
    return eingabe_BWL;
}
